import styled from '@emotion/styled';
import { Chip, ClickAwayListener, Paper, Tooltip, TooltipProps, Typography, tooltipClasses } from '@mui/material';
import { FunctionComponent, useContext, useState } from 'react';
import { ScreenLabelsContext } from '../../../../context/screen-labels/screen-labels';
import { getDisplayLabel as getDisplayLabelUtil } from '../../../../shared/utils/screen-labels';

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "transparent",
    margin: 0,
    padding: 0,
  },
}));

export const AnalyticTooltipChip: FunctionComponent<{ filter: string, index: number, array: string }> = ({ filter, index, array }) => {
  const [active, setActive] = useState<boolean>(false);
  const screenLabelsContext = useContext(ScreenLabelsContext);

  const displayFilter = getDisplayLabelUtil(filter, screenLabelsContext.getLabel);
  return (
    <StyledTooltip
      PopperProps={{
        disablePortal: true,
      }}
      key={index}
      onClose={() => setActive(!active)}
      open={active}
      disableFocusListener
      disableHoverListener
      disableTouchListener
      title={<ClickAwayListener onClickAway={() => setActive(false)}>
        <Paper sx={{ p: 1 }} elevation={3}>
          <Typography variant='body2' color='text.primary' sx={{ whiteSpace: 'pre-wrap' }}>{array}
          </Typography>
        </Paper>
      </ClickAwayListener>}
      placement='right'
    >
      <Chip color='primary' variant='outlined' sx={{ maxWidth: '250px' }}
        label={`${displayFilter}: ${array}`}
        onClick={() => setActive(!active)}
      />
    </StyledTooltip >
  )

}